import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from '../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { SharePointOnlineListCopySource } from 'app/model/pipeline/copysource/sharepoint-online-list.copysource';
import { commonCopySourceAdapts, CopySourceAdapter } from './copysource.adapter';
import { ValueAdapter } from '../../value.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SharePointOnlineListCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*',
        httpRequestTimeout: '*'
    }
})
export class SharePointOnlineListCopySourceAdapter extends CopySourceAdapter<
    SharePointOnlineListCopySource,
    Model.SharePointOnlineListCopySource
> {
    protected override async _toResource(
        copySource: SharePointOnlineListCopySource
    ): Promise<Model.SharePointOnlineListCopySource> {
        const result = this._toTabularResource(copySource, Metamodel.modelFor(SharePointOnlineListCopySource).name);
        result.httpRequestTimeout = ValueAdapter.toResource(
            copySource,
            SharePointOnlineListCopySource.HTTP_REQUEST_TIMEOUT
        );
        return result;
    }

    protected override async _toModel(
        resource: Model.SharePointOnlineListCopySource,
        copyActivity: CopyActivity
    ): Promise<SharePointOnlineListCopySource> {
        const result = this._toTabularModel(resource, copyActivity, SharePointOnlineListCopySource.MODEL);
        ValueAdapter.toModel(result, SharePointOnlineListCopySource.HTTP_REQUEST_TIMEOUT, resource.httpRequestTimeout);
        return result;
    }
}
